const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */
const React = require('react');

const {formatText} = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

const mockHelper = require('../../../utilities/mockDataHelper');

class OtherIncome extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }


    handleOnBlur(event) {
        this.props.handleBlur(event, this.props.rowIndex);
    }

    handleOnChange(event) {
        this.props.handleChange(event, this.props.rowIndex);
    }


    render() {
        return (
            <div className="laboral-data laboral-data__input-row">
                <div className="laboral-data__workers-data--first-row laboral-data__form-element laboral-data__padding-top">
                    {this.props.rowIndex === 0 ? <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataOtherIncomeOriginTitle')}</div> : null}
                    <InputSafe
                        label={null}
                        name="origin"
                        onBlur={this.handleOnBlur}
                        onChange={null}
                        referenceName="origin"
                        type="text"
                        value={this.props.values.origin}
                    />
                </div>
                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                    {this.props.rowIndex === 0 ? <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataOtherIncomePeriodicityTitle')}</div> : null}
                    <OKSelect
                        placeholder={formatText('contractsView-checkingAccountLaboralDataOtherIncomeSelectPlaceholderTitle')}
                        searchable={true}
                        options={mockHelper.mockPeriodicity()}
                        onChange={this.handleOnChange}
                        value={this.props.values.periodicity}
                    />
                </div>
                <div className="laboral-data__workers-data--first-row laboral-data__form-element laboral-data__padding-top">
                    {this.props.rowIndex === 0 ? <div className="ok-slider__text">{formatText('contractsView-amount')}</div> : null}
                    <InputSafe
                        label={null}
                        name="amount"
                        onBlur={this.handleOnBlur}
                        onChange={null}
                        referenceName="amount"
                        type="text"
                        value={this.props.values.amount}
                    />
                </div>
            </div>
        );
    }
}

OtherIncome.propTypes = {
    values: PropTypes.object,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    rowIndex: PropTypes.number
};

module.exports = OtherIncome;